export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Chemical Engineer | London',
    'I finally understand the complete picture of industrial chemistry—from fundamentals through unit operations, chemical production, process control, safety, and troubleshooting. This resource transformed how I approach chemistry projects professionally.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Plant Operator | Dublin',
    'I know exactly how to explain chemical reactions, industrial equipment, manufacturing processes, automation systems, and process optimization. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Process Specialist | Amsterdam',
    'The technical depth saves me countless hours. The integrated scenarios are organized step-by-step. I never struggle with technical explanations anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Chemistry Professional',
    "Industrial chemistry fundamentals and unit operations completely changed how I understand chemical production. It's the clearest technical resource I've found.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Plant Technician',
    'The technical glossary and equipment handbook alone are worth the price. I never struggle with technical terminology or equipment decisions anymore. Everything is organized and accessible.',
  ],
  [
    'MS',
    'Martin S.',
    'Process Engineer',
    'The 12 industry case studies and 24 calculation examples were eye-opening. I can now explain chemical reactions, equipment operation, process control, production optimization, and troubleshooting across reactors, distillation systems, heat exchangers, and manufacturing processes. This transformed my professional credibility.',
  ],
];
